import Vuex from 'vuex'
import mqtt from 'mqtt'
import env from '@/environments/environment'

const mqttStore = new Vuex.Store({
    state: {
        cli: null,
        subscribtions: []
    },
    mutations: {
        connect(state, { client }) {
            state.cli = client;
        },
        disconnect(state) {
            state.cli = null;
        },
        subscribe(state, { topic }) {
            state.subscribtions.push(topic);
        },
        unsubscribe(state, { topic }) {
            const index = state.subscribtions.indexOf(topic);
            if (index > -1) {
                state.subscribtions.splice(index, 1);
            }
        }
    },
    actions: {
        connect({ commit }, { url, username, password }) {
            return new Promise((res, rej) => {
                const cli = mqtt.connect(url, {
                    protocol: env.mqtt.protocol,
                    username,
                    password
                });

                cli.setMaxListeners(100);

                cli.once('connect', () => {
                    commit('connect', { client: cli });
                    res(cli);
                });

                cli.once('error', (e) => rej(e));
            })
        },
        disconnect({ commit, state }) {
            state.cli.once('end', () => {
                commit('disconnect');
            });

            state.cli.end();

            state.subscribtions.forEach(topic => commit('unsubscribe', { topic }))
        },
        subscribe({ commit, state }, { topic }) {
            state.cli.subscribe(topic, { qos: 0 });
            commit('subscribe', { topic });
        },
        unsubscribe({ commit, state }, { topic }) {
            state.cli.unsubscribe(topic, { qos: 0 });
            commit('unsubscribe', { topic });
        }
    }
})

export default mqttStore